import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Tag from '../Tag/Tag';
import { removeFilterDrawnLayer, updateProperties, clearFilters as clear, removeFilter as remove } from '../../store/actions';

import svgInline from '../SvgInline/SvgInline';
import ClearIcon from './icon-clear.svg';
import './AppliedSearch.css';

export class AppliedSearchComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterTags: [...props.filters],
    };
    this.addCommas = this.addCommas.bind(this);
    this.formatKey = this.formatKey.bind(this);
    this.formatValue = this.formatValue.bind(this);
    this.deleteFilters = this.deleteFilters.bind(this);
    this.removeFilterTag = this.removeFilterTag.bind(this);
  }

  componentWillReceiveProps(props) {
    this.setState({ filterTags: [...props.filters] });
  }

  addCommas = value => {
    return (typeof value === 'number') ? value.toLocaleString() : value;
  }

  formatKey = key => {
    switch (key) {
      case 'saleLease':
        return 'Sale/Lease';
      case '_id':
        return 'Properties';
      case 'projects':
        return 'Showing';
      default:
        return key
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, str => str.toLocaleUpperCase());
    }
  }

  formatValue = (value, key, filters) => {
    if (key === '_id') {
      return value.length;
    }

    if (key === 'projects' && filters.projects && filters.projects.length > 0) {
      const projects = filters.projects;
      if (Array.isArray(value)) {
        if (value.length === 1 && value.some(v => v === '0')) {
          return 'All Properties';
        }
        return value.filter(v => v !== '0').map(v => (projects.find(p => String(p._id) === String(v)) || {}).name).join(', ');
      }
      if (value !== '0') {
        return projects.find(p => String(p._id) === String(value)).name;
      }
      return 'All Properties';
    }

    if (key === 'shapefile') {
      return value.title;
    }

    if (Array.isArray(value)) {
      return value.length > 0 && value[0].name
        ? value.map(v => v.name).join(' - ')
        : value.map(this.addCommas).join(' - ');
    }

    if (typeof value === 'object' && value.coordinates) {
      return value.type;
    }

    return value.name
      ? value.name
      : this.addCommas(value);
  }

  deleteFilters = () => {
    this.props.clearFilters(this.props);
    setTimeout(() => {
      this.props.updatePropertiesAfterFiltersChange(this.props);
    }, 50);
  }

  removeFilterTag = filter => {
    this.props.removeFilter({ filter, ...this.props });
    setTimeout(() => {
      this.props.updatePropertiesAfterFiltersChange(this.props);
    }, 50);
  }

  render() {
    const { filterValues, filters } = this.props;
    const isOpenClassName = filters.size > 0 ? 'applied-search-open' : 'applied-search-closed';
    const shape = filters.get('shape') ? filters.get('shape') : {};
    const circleMiles = shape && shape.type === 'Circle' ? (((shape.radius / 1609) ** 2) * 3.141593).toFixed(0) : '';
    const circleRadius = shape && shape.type === 'Circle' ? (shape.radius / 1609).toFixed(1) : 0;
    const polyArea = shape && shape.type !== 'Circle' && shape.area ? (shape.area).toFixed(0) : '';
    const polyWidth = shape && shape.type !== 'Circle' && shape.width ? (shape.width).toFixed(1) : '';
    const polyHeight = shape && shape.type !== 'Circle' && shape.height ? (shape.height).toFixed(1) : '';
    const filterTags = this.state.filterTags.reduce((acc, filter) => {
      const f = [...filter];
      if (f[0] === 'projects' && f[1].length === 2 && f[1][0] === '10' && f[1][1] === '11') {
        f[1] = f[1].filter(v => v !== '10' && v !== '11');
        if (f[1].length > 0) {
          acc.push(f);
        }
      } else {
        acc.push(f);
      }
      return acc;
    }, []);
    return (
      <div className={`applied-search ${isOpenClassName}`}>
        <div className="applied-search-label">
          Applied Search:

          {filterTags.map(([key, value]) => (
            <Tag onClose={() => { this.removeFilterTag(key); }} key={key}>
              {`${this.formatKey(key)}: ${this.formatValue(value, key, filterValues)}`}
            </Tag>
          ))}
        </div>

        {shape.type === 'Circle' &&
          <span className="applied-search-measurements">
            <span>
              <b>Radius:</b> {circleRadius} mi. | <b>Area:</b> {circleMiles} sq.mi.
            </span>
          </span>
        }

        {shape.type !== 'Circle' &&
          <span className="applied-sarch-measurements">
            <span>
              <b>Width:</b> {polyWidth} mi. |&nbsp;
              <b>Height:</b> {polyHeight} mi. |&nbsp;
              <b>Area:</b> {polyArea} sq. mi.
            </span>
          </span>
        }

        <button className="applied-search-clear" onClick={this.deleteFilters}>
          <div className="applied-search-clear-icon">{svgInline(ClearIcon)}</div>
          <span className="applied-search-clear-text">Clear Search</span>
        </button>
      </div>
    );
  }
}

AppliedSearchComponent.propTypes = {
  filters: PropTypes.object.isRequired,
  filterValues: PropTypes.object.isRequired,
  propertyType: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  removeFilter: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  updatePropertiesAfterFiltersChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { propertyType }) => {
  return ({
    filters: state[propertyType].filters,
    organizationId: state.organizationId,
    sort: state[propertyType].sort,
    previouslySearchedLayer: state.saveSearchedLayers,
  });
};

/* istanbul ignore next */
const mapDispatchToProps = dispatch => {
  return {
    updatePropertiesAfterFiltersChange: ({
      propertyType,
      filters,
      sort,
      organizationId,
      previouslySearchedLayer,
    }) => {
      dispatch(
        updateProperties(
          propertyType,
          filters,
          sort,
          organizationId,
          undefined,
          previouslySearchedLayer,
        ),
      );
    },
    removeFilter: ({ propertyType, previouslySearchedLayer, filter }) => {
      if (filter === 'shape') {
        dispatch(removeFilterDrawnLayer(propertyType));
      }
      if (filter === 'shapefile') {
        dispatch(removeFilterDrawnLayer(propertyType));
      }
      dispatch(remove(propertyType, filter, previouslySearchedLayer));
    },
    clearFilters: ({ propertyType }) => {
      dispatch(clear(propertyType));
      dispatch(removeFilterDrawnLayer(propertyType));
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AppliedSearchComponent);



// WEBPACK FOOTER //
// ./src/components/AppliedSearch/AppliedSearch.js